import { TRIMMED_INPUT_REGEX } from 'constants/constants';
import { EPopupSubType, OfferType } from 'constants/enums';
import { z } from 'zod';

export const DAILY_BONUS_SCHEMA = z.object({
  _id: z.string().optional(),
  active: z.boolean(),
  name: z
    .string()
    .min(1, 'Name is required')
    .refine((value) => TRIMMED_INPUT_REGEX.test(value), {
      message: 'Name should not be spaces'
    }),
  displayName: z.string().optional(),
  subType: z.nativeEnum(EPopupSubType),
  description: z
    .string()
    .optional()
    .refine((value) => !value || value.length >= 3, {
      message: 'Description length should be at least 3 characters',
      path: ['description']
    }),
  publisherOfferId: z
    .string()
    .min(1, 'External ID is required')
    .refine((value) => TRIMMED_INPUT_REGEX.test(value), {
      message: 'External ID should not be spaces'
    }),
  offerUiId: z.string().min(1, 'Offer Design is required'),
  priority: z.number().min(1).nullable(),
  startOver: z.boolean(),
  segments: z.array(z.string()),
  type: z.nativeEnum(OfferType),
  productName: z.string().optional(),
  quantity: z.number(),
  products: z.array(z.any()).optional()
});

export type DailyBonusFormFields = z.infer<typeof DAILY_BONUS_SCHEMA>;

export const DAILY_BONUS_DEFAULT_VALUES: DailyBonusFormFields = {
  active: true,
  name: '',
  displayName: '',
  subType: EPopupSubType.DAILY_BONUS,
  description: '',
  publisherOfferId: '',
  offerUiId: '',
  priority: 1,
  startOver: true,
  segments: [],
  type: OfferType.POPUP,
  productName: '',
  quantity: 1,
  products: []
};
